import type { AppLocale, MessageTree } from "@airange/shared/i18n-common";

export const redblueCommonValuesMessages: Record<AppLocale, MessageTree> = {
  "zh-CN": {
    redblue: {
      values: {
        modes: {
          scripted: "剧本演练",
          free: "自由对抗",
          real_network: "实网对抗",
        },
        statuses: {
          draft: "草稿",
          active: "启用",
          archived: "已归档",
          planned: "已计划",
          scheduled: "待准备",
          preparing: "准备中",
          prepared: "已准备",
          running: "进行中",
          ended: "已结束",
          cancelled: "已取消",
          terminated: "已终止",
          published: "已发布",
        },
        sourceTypes: {
          free: "自由对抗",
          scheme_version: "基于发布方案版本",
        },
        sharedResourceScopes: {
          mine: "我的",
          shared_with_me: "共享给我的",
          public: "公共",
          all: "全部",
        },
        memberRoles: {
          portal_member: "前台成员",
          exercise_manager: "演练管理者",
          platform_manager: "平台管理员",
        },
        activityMemberRoles: {
          director: "导调员",
          judge: "裁判员",
          red: "红方成员",
          blue: "蓝方成员",
          observer: "观察员",
          captain: "队长",
        },
        createModes: {
          free: "自由对抗",
          scheme_version: "基于发布方案版本",
          from_scheme: "基于发布方案版本",
        },
        taskTypes: {
          manual: "手动任务",
          flag: "夺旗",
          subjective: "主观任务",
        },
        dispatchModes: {
          manual: "手动下发",
        },
        flowStatuses: {
          pending_dispatch: "待下发",
          dispatched: "已下发",
          completed: "已完成",
        },
        scoringStatuses: {
          pending_score: "待计分",
          pending_judge: "待裁判复核",
          scored: "已计分",
        },
        dispatchTargetTypes: {
          all: "全体",
          camp: "阵营",
          seat: "席位",
          captain: "队长席位",
        },
        noticeTargetTypes: {
          all: "全体",
          camp: "阵营",
          seat: "席位",
          member: "成员",
          role: "角色",
        },
        noticeTypes: {
          director_announcement: "导调公告",
        },
        scoreKinds: {
          flag: "夺旗计分",
          subjective: "主观评分",
          director_penalty: "导调扣分",
          adjustment: "人工调整",
        },
        scoreStatuses: {
          pending: "待复核",
          confirmed: "已确认",
          rejected: "已驳回",
        },
        reportTypes: {
          camp: "阵营报告",
          task: "任务报告",
          task_submission: "任务提交",
          free: "自由报告",
        },
        reportStatuses: {
          draft: "草稿",
          submitted: "已提交",
        },
        eventTypes: {
          task_dispatched: "任务已下发",
          task_assigned_to_seat: "任务已分配到席位",
          ad_hoc_task_created: "临时任务已创建",
          notice_published: "公告已发布",
          director_penalty_created: "导调扣分已创建",
          judge_score_created: "裁判评分已创建",
          score_record_reviewed: "评分记录已复核",
          score_record_adjusted: "评分记录已调整",
          final_score_confirmed: "最终成绩已确认",
          flag_rejected: "夺旗结果已驳回",
          flag_accepted: "夺旗结果已确认",
          task_completed: "任务已完成",
          report_submitted: "报告已提交",
          report_draft_created: "报告草稿已创建",
          task_submission_submitted: "任务提交已送出",
          report_updated: "报告已更新",
          task_auto_dispatched: "任务已自动下发",
          activity_members_replaced: "活动成员已替换",
          activity_prepared: "活动已准备",
          activity_started: "活动已开始",
          activity_ended: "活动已结束",
          activity_archived: "活动已归档",
          activity_scheduled: "活动已计划",
          activity_cancelled: "活动已取消",
          activity_terminated: "活动已终止",
          activity_topology_released: "活动拓扑已发布",
        },
        subjectTypes: {
          activity: "演练活动",
          activity_task: "活动任务",
          activity_notice: "活动公告",
          activity_report: "活动报告",
          activity_score_record: "活动评分记录",
          activity_topology_binding: "活动拓扑绑定",
        },
        booleans: {
          yes: "是",
          no: "否",
          enabled: "开启",
          disabled: "关闭",
        },
        countUnit: "个",
      },
    },
  },
  en: {
    redblue: {
      values: {
        modes: {
          scripted: "Scripted",
          free: "Free",
          real_network: "Real Network",
        },
        statuses: {
          draft: "Draft",
          active: "Active",
          archived: "Archived",
          planned: "Planned",
          scheduled: "Scheduled",
          preparing: "Preparing",
          prepared: "Prepared",
          running: "Running",
          ended: "Ended",
          cancelled: "Cancelled",
          terminated: "Terminated",
          published: "Published",
        },
        sourceTypes: {
          free: "Free Exercise",
          scheme_version: "From Published Scheme Version",
        },
        sharedResourceScopes: {
          mine: "Mine",
          shared_with_me: "Shared with me",
          public: "Public",
          all: "All",
        },
        memberRoles: {
          portal_member: "Portal member",
          exercise_manager: "Exercise manager",
          platform_manager: "Platform administrator",
        },
        activityMemberRoles: {
          director: "Director",
          judge: "Judge",
          red: "Red team member",
          blue: "Blue team member",
          observer: "Observer",
          captain: "Captain",
        },
        createModes: {
          free: "Free Exercise",
          scheme_version: "From Published Scheme Version",
          from_scheme: "From Published Scheme Version",
        },
        taskTypes: {
          manual: "Manual",
          flag: "Flag",
          subjective: "Subjective",
        },
        dispatchModes: {
          manual: "Manual Dispatch",
        },
        flowStatuses: {
          pending_dispatch: "Pending Dispatch",
          dispatched: "Dispatched",
          completed: "Completed",
        },
        scoringStatuses: {
          pending_score: "Pending Score",
          pending_judge: "Pending Judge Review",
          scored: "Scored",
        },
        dispatchTargetTypes: {
          all: "All",
          camp: "Camp",
          seat: "Seat",
          captain: "Captain Seat",
        },
        noticeTargetTypes: {
          all: "All",
          camp: "Camp",
          seat: "Seat",
          member: "Member",
          role: "Role",
        },
        noticeTypes: {
          director_announcement: "Director Announcement",
        },
        scoreKinds: {
          flag: "Flag Score",
          subjective: "Subjective Score",
          director_penalty: "Director Penalty",
          adjustment: "Manual Adjustment",
        },
        scoreStatuses: {
          pending: "Pending Review",
          confirmed: "Confirmed",
          rejected: "Rejected",
        },
        reportTypes: {
          camp: "Camp Report",
          task: "Task Report",
          task_submission: "Task Submission",
          free: "Free Report",
        },
        reportStatuses: {
          draft: "Draft",
          submitted: "Submitted",
        },
        eventTypes: {
          task_dispatched: "Task Dispatched",
          task_assigned_to_seat: "Task Assigned to Seat",
          ad_hoc_task_created: "Ad Hoc Task Created",
          notice_published: "Announcement Published",
          director_penalty_created: "Director Penalty Created",
          judge_score_created: "Judge Score Created",
          score_record_reviewed: "Score Record Reviewed",
          score_record_adjusted: "Score Record Adjusted",
          final_score_confirmed: "Final Score Confirmed",
          flag_rejected: "Flag Rejected",
          flag_accepted: "Flag Accepted",
          task_completed: "Task Completed",
          report_submitted: "Report Submitted",
          report_draft_created: "Report Draft Created",
          task_submission_submitted: "Task Submission Submitted",
          report_updated: "Report Updated",
          task_auto_dispatched: "Task Auto Dispatched",
          activity_members_replaced: "Activity Members Replaced",
          activity_prepared: "Activity Prepared",
          activity_started: "Activity Started",
          activity_ended: "Activity Ended",
          activity_archived: "Activity Archived",
          activity_scheduled: "Activity Scheduled",
          activity_cancelled: "Activity Cancelled",
          activity_terminated: "Activity Terminated",
          activity_topology_released: "Activity Topology Released",
        },
        subjectTypes: {
          activity: "Activity",
          activity_task: "Activity Task",
          activity_notice: "Activity Announcement",
          activity_report: "Activity Report",
          activity_score_record: "Activity Score Record",
          activity_topology_binding: "Activity Topology Binding",
        },
        booleans: {
          yes: "Yes",
          no: "No",
          enabled: "Enabled",
          disabled: "Disabled",
        },
        countUnit: "items",
      },
    },
  },
  ja: {
    redblue: {
      values: {
        modes: {
          scripted: "シナリオ演習",
          free: "フリー対抗",
          real_network: "実ネットワーク対抗",
        },
        statuses: {
          draft: "下書き",
          active: "有効",
          archived: "アーカイブ済み",
          planned: "計画済み",
          scheduled: "準備待ち",
          preparing: "準備中",
          prepared: "準備完了",
          running: "実行中",
          ended: "終了",
          cancelled: "キャンセル済み",
          terminated: "強制終了",
          published: "公開済み",
        },
        sourceTypes: {
          free: "フリー対抗",
          scheme_version: "公開済みプラン版から作成",
        },
        sharedResourceScopes: {
          mine: "自分のもの",
          shared_with_me: "共有されたもの",
          public: "公共",
          all: "すべて",
        },
        memberRoles: {
          portal_member: "フロント利用者",
          exercise_manager: "演習管理者",
          platform_manager: "プラットフォーム管理者",
        },
        activityMemberRoles: {
          director: "ディレクター",
          judge: "審判",
          red: "赤チームメンバー",
          blue: "青チームメンバー",
          observer: "オブザーバー",
          captain: "キャプテン",
        },
        createModes: {
          free: "フリー対抗",
          scheme_version: "公開済みプラン版から作成",
          from_scheme: "公開済みプラン版から作成",
        },
        taskTypes: {
          manual: "手動",
          flag: "フラッグ",
          subjective: "主観タスク",
        },
        dispatchModes: {
          manual: "手動配布",
        },
        flowStatuses: {
          pending_dispatch: "配布待ち",
          dispatched: "配布済み",
          completed: "完了",
        },
        scoringStatuses: {
          pending_score: "採点待ち",
          pending_judge: "審判レビュー待ち",
          scored: "採点済み",
        },
        dispatchTargetTypes: {
          all: "全体",
          camp: "陣営",
          seat: "席位",
          captain: "隊長席位",
        },
        noticeTargetTypes: {
          all: "全体",
          camp: "陣営",
          seat: "席位",
          member: "メンバー",
          role: "ロール",
        },
        noticeTypes: {
          director_announcement: "ディレクター告知",
        },
        scoreKinds: {
          flag: "フラッグ採点",
          subjective: "主観採点",
          director_penalty: "ディレクター減点",
          adjustment: "手動調整",
        },
        scoreStatuses: {
          pending: "レビュー待ち",
          confirmed: "確認済み",
          rejected: "却下",
        },
        reportTypes: {
          camp: "陣営レポート",
          task: "タスクレポート",
          task_submission: "タスク提出",
          free: "自由レポート",
        },
        reportStatuses: {
          draft: "下書き",
          submitted: "提出済み",
        },
        eventTypes: {
          task_dispatched: "タスクを配布しました",
          task_assigned_to_seat: "タスクを席位へ割り当てました",
          ad_hoc_task_created: "臨時タスクを作成しました",
          notice_published: "告知を公開しました",
          director_penalty_created: "ディレクター減点を作成しました",
          judge_score_created: "審判採点を作成しました",
          score_record_reviewed: "採点記録をレビューしました",
          score_record_adjusted: "採点記録を調整しました",
          final_score_confirmed: "最終得点を確定しました",
          flag_rejected: "フラッグ結果を却下しました",
          flag_accepted: "フラッグ結果を確認しました",
          task_completed: "タスクが完了しました",
          report_submitted: "レポートを提出しました",
          report_draft_created: "レポート下書きを作成しました",
          task_submission_submitted: "タスク提出を送信しました",
          report_updated: "レポートを更新しました",
          task_auto_dispatched: "タスクを自動配布しました",
          activity_members_replaced: "活動メンバーを置き換えました",
          activity_prepared: "活動を準備完了にしました",
          activity_started: "活動を開始しました",
          activity_ended: "活動を終了しました",
          activity_archived: "活動をアーカイブしました",
          activity_scheduled: "活動を計画しました",
          activity_cancelled: "活動をキャンセルしました",
          activity_terminated: "活動を強制終了しました",
          activity_topology_released: "活動トポロジーを公開しました",
        },
        subjectTypes: {
          activity: "演習活動",
          activity_task: "活動タスク",
          activity_notice: "活動告知",
          activity_report: "活動レポート",
          activity_score_record: "活動採点記録",
          activity_topology_binding: "活動トポロジー紐付け",
        },
        booleans: {
          yes: "はい",
          no: "いいえ",
          enabled: "有効",
          disabled: "無効",
        },
        countUnit: "件",
      },
    },
  },
};
